export const RESTRICTED_IMAGE_STYLE = { filter: 'grayscale(0.85) opacity(0.55)' };

export const RESTRICTED_BG_CLASS = 'bg-[#F1EDE7]';
export const RESTRICTED_FG_HEX = '#A39B8E';

export const SCHEDULE_OPEN_TEXT_CLASS = 'text-[#1E8F4E]';
export const SCHEDULE_CLOSED_TEXT_CLASS = 'text-[#6B655C]';
